module.exports = __webpack_public_path__ + "static/media/jingteshu2.df1282fe.png";